import { render, staticRenderFns } from "./productar.vue?vue&type=template&id=7341f04d&"
import script from "./productar.vue?vue&type=script&lang=js&"
export * from "./productar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports